export const REGEX_URL =
  /^(https?:\/\/)([\da-z\\.-]+)\.([a-z\\.]{2,6})(\/([\da-z\\.-]+))*\/?(([\w\\.-]+)\.([\da-z]{2,6}))?((\\#[\w\\.-]+)|(\?([\da-z]+(=[\da-z]+)?)(&([\da-z]+(=[\da-z]+)?))*))?/;
